import { useEffect } from 'react';
import { useFormik } from 'formik';
import { Quotation } from '../../../../../../shared/types/modules/quotation';

export const useDetaileQuotation = (quotation?: Quotation) => {
    const formik = useFormik({
        initialValues: {
            created_at: '',
            createdBy: '',
            updatedBy: '',
            channel: '',
            callId: '',
            typeQuotation: '',
            typification: '',
            subtypification: '',
            bouquet: '',
            body: '',
            template: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const {
            created_at = '',
            callId: callInfoRaw = '',
            createdBy: createdByRaw = '',
            updatedBy: updatedByRaw = '',
            template = '',
            body = '',
        } = quotation || {};
        const callInfo =
            typeof callInfoRaw === 'string'
                ? callInfoRaw
                : (callInfoRaw as string) || '';
        const createdBy =
            createdByRaw && typeof createdByRaw === 'object'
                ? `${createdByRaw.name ?? ''} ${
                    createdByRaw.surname ?? ''
                }`.trim()
                : '';
        const updatedBy =
            createdByRaw && typeof updatedByRaw === 'object'
                ? `${updatedByRaw.name ?? ''} ${
                    updatedByRaw.surname ?? ''
                }`.trim()
                : '';
        const formattedCreatedAt =
            created_at instanceof Date
                ? created_at.toISOString()
                : created_at || '';
        const channelName =
            typeof quotation?.channel === 'object' && quotation?.channel?.name
                ? quotation.channel.name
                : '';
        const bouquetName =
            typeof quotation?.bouquet === 'object' && quotation?.bouquet?.name
                ? quotation.bouquet.name
                : '';
        const typeQuotationName =
            typeof quotation?.typeQuotation === 'object' &&
            quotation?.typeQuotation?.name
                ? quotation.typeQuotation.name
                : '';
        const typificationName =
            typeof quotation?.typification === 'object' &&
            quotation?.typification?.name
                ? quotation.typification.name
                : '';
        const subtypificationName =
            typeof quotation?.subtypification === 'object' &&
            quotation?.subtypification?.name
                ? quotation?.subtypification.name
                : '';

        formik.setValues({
            created_at: formattedCreatedAt,
            callId: callInfo,
            createdBy,
            updatedBy,
            channel: channelName,
            bouquet: bouquetName,
            typeQuotation: typeQuotationName,
            typification: typificationName,
            subtypification: subtypificationName,
            template: template as string,
            body: body,
        });
    }, [quotation]);

    return {
        formik,
    };
};
